module.exports = __webpack_public_path__ + "img/user_icon.bfde2114.png";